import axios from 'axios';
import axiosInstance from 'common/utils/axiosInstance';

export const uploadImage = async file => {
  const cloudinaryConfig = {
    apiKey: window.env?.CLOUDINARY_API_KEY,
    cloudName: window.env?.CLOUDINARY_CLOUD_NAME,
  };
  const formData = new FormData();
  const formParams = {
    file: file,
    upload_preset: 'rytykijt',
    folder: 'user_photos',
    cloud_name: cloudinaryConfig.cloudName,
    timestamp: Math.floor(Date.now() / 1000),
    api_key: cloudinaryConfig.apiKey,
  };

  for (const key in formParams) {
    formData.append(key, formParams[key]);
  }

  const signing_params = Object.keys(formParams).reduce((acc, key) => {
    for (const invalid_param of ['file', 'cloud_name', 'resource_type', 'api_key']) {
      if (invalid_param === key) {
        return acc;
      }
    }
    return { ...acc, [key]: formParams[key] };
  }, {});

  const { signature } = (
    await axiosInstance.post('/api/v1/cloudinary_signatures', { signing_params })
  ).data;
  formData.append('signature', signature);

  const response = await axios.post(
    `https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloudName}/upload`,
    formData
  );
  return response;
};

export const getCustomLegacyRoles = async () => {
  const response = await axios.get('/api/v1/legacy_roles');
  return response;
};
